export default "__VITE_ASSET__CCgm0emA__"